import { ImageCustom } from '@/components';
import { ICartInfoItem } from '@/models';
import Link from 'next/link';
import React from 'react';

interface ICartItemOrder {
	data: ICartInfoItem;
}

const CartItemOrder: React.FC<ICartItemOrder> = ({ data }) => {
	return (
		<div className='flex relative gap-[20px] text-base first-of-type:pt-0 last-of-type:border-b-0 py-[30px] border-b border-gray-custom'>
			<div className='min-w-[90px] h-full aspect-square overflow-hidden'>
				<ImageCustom fill src={data?.product_image} objectFit='contain' className='!h-full' />
			</div>
			<div className='hidden lg:flex flex-col flex-auto lg:flex-row flex-nowrap gap-2 lg:gap-4 items-center'>
				<div className='group'>
					<div
						className='tooltip w-full flex-auto flex group-hover:tooltip-open whitespace-normal break-words before:bg-black/25 after:border-[black_transparent_transparent_transparent]'
						data-tip={data?.product_name}
					>
						<div className='flex-[0_0_40%] max-w-[40%] lg:flex-[0_0_120px] xl:flex-[0_0_150px] text-right lg:text-left lg:max-w-[120px] xl:max-w-[150px] flex-col gap-2'>
							<Link
								href={'/product-detail/[slug]'}
								as={`/chi-tiet/${data?.product_id}`}
								className='line-clamp-1 text-primary font-bold mb-[6px]'
							>
								{data?.product_name}
							</Link>
							<p className='text-[#71717A]'>{data?.variation_name}</p>
						</div>
					</div>
				</div>
				<div className='flex flex-auto w-full lg:w-auto flex-col text-[#645C55] gap-2'>
					<p className='lg:text-left flex justify-end lg:justify-start'>
						Đơn giá: {Number(data?.price)?.toLocaleString('it-IT')}₫
					</p>
					<p className='flex justify-end lg:justify-start'>Số lượng: {data?.quantity}</p>
				</div>
				<span className='font-bold w-full lg:w-auto justify-end lg:justify-start flex lg:block text-primary'>
					{Number(+data?.price * data?.quantity)?.toLocaleString('it-IT')}₫
				</span>
			</div>
			{/* mobile */}
			<div className='flex flex-col max-w-[calc(100%_-_112px)] lg:hidden'>
				<Link
					href={'/product-detail/[slug]'}
					as={`/chi-tiet/${data?.product_id}`}
					className='text-right text-base lg:text-medium break-words font-bold mb-[6px]'
				>
					{data?.product_name}
				</Link>
				<p className='text-[#71717A] text-right'>{data?.variation_name}</p>
				<div className='flex flex-auto w-full lg:w-auto flex-col text-[#645C55] gap-2'>
					<p className='flex justify-end lg:justify-start'>
						Đơn giá: {Number(data?.price)?.toLocaleString('it-IT')}₫
					</p>
					<p className='flex justify-end lg:justify-start'>Số lượng: {data?.quantity}</p>
				</div>
				<span className='font-bold w-full lg:w-auto justify-end lg:justify-start flex lg:block text-primary'>
					{Number(+data?.price * data?.quantity)?.toLocaleString('it-IT')}₫
				</span>
			</div>
		</div>
	);
};

export default CartItemOrder;
